import { usePluralCopy } from '@components/hooks';
import {
  bulkEditFields,
  BulkEditFieldState,
} from '@components/modals/BulkEditModal/constants/base';
import { AlertTitle } from '@mui/material';

export const ReviewInvalidError = ({
  invalidCount,
  field,
}: {
  field: BulkEditFieldState;
  invalidCount: number;
}) => {
  const  getPluralCopy  = usePluralCopy(invalidCount);
  const plural = getPluralCopy({
    singular: () => 'Ad Group has',
    plural: () => 'Ad Groups have',
  });
  let error = null;

  switch(field) {
    case bulkEditFields.AD_GROUP_DATES_TIMES:
      error = `${invalidCount} ${plural} a start date that is later than the new end date.`
      break;
    default:
      error = `${invalidCount} ${plural} errors and cannot be edited right now.`
      break;
  }

  return (
    <AlertTitle>
      {error}
    </AlertTitle>
  );
};
